// src/FirebaseConfig.js
import { APPLICATIONS, FORCE_APP } from './initializer';

/**
 * Resolve the current application using hostname or FORCE_APP (dev).
 * @returns {Record<string, any>} Selected app object
 */
function resolveApp() {
  const domain = window.location.hostname;

  if (FORCE_APP) {
    if (typeof FORCE_APP === 'string') {
      const byId = APPLICATIONS.find(a => a?.ID === FORCE_APP || a?.name === FORCE_APP);
      if (byId) return byId;
    } else if (typeof FORCE_APP === 'object' && FORCE_APP?.ID) {
      return FORCE_APP;
    }
  }

  const byDomain =
    APPLICATIONS.find(app => Array.isArray(app?.DOMAINS) && app.DOMAINS.includes(domain)) || null;

  return byDomain || APPLICATIONS[0];
}

/**
 * @param {Record<string, any>} app
 * @returns {import('firebase/app').FirebaseOptions}
 */
function toFirebaseOptions(app) {
  const cfg = app?.FIREBASE_CONFIG || {};
  return {
    apiKey: cfg.apiKey ?? cfg.API_KEY,
    authDomain: cfg.authDomain ?? cfg.AUTH_DOMAIN,
    projectId: cfg.projectId ?? cfg.PROJECT_ID,
    storageBucket: cfg.storageBucket ?? cfg.STORAGE_BUCKET,
    messagingSenderId: cfg.messagingSenderId ?? cfg.MESSAGING_SENDER_ID,
    appId: cfg.appId ?? cfg.APP_ID,
    measurementId: cfg.measurementId ?? cfg.MEASUREMENT_ID,
    databaseURL: cfg.databaseURL ?? cfg.DATABASE_URL,
  };
}

const FirebaseConfig = toFirebaseOptions(resolveApp());
export default FirebaseConfig;
